// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
export const PhoneOverrideService = {
    // Create the override option
    Create(fn, req) {
        return fn(`/phone/override/v1`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    // Read the override
    Read(fn, req) {
        try {
            fm.validateUrlParam(req["phoneOverrideId"], "phoneOverrideId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/override/v1/${req["phoneOverrideId"]}?${fm.renderURLSearchParams(req, ["phoneOverrideId"])}`, { method: "GET" });
    },
    // List overrides for the given location
    List(fn, req) {
        return fn(`/phone/override/v1?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    // Update the given override option with the fields provided
    Update(fn, req) {
        return fn(`/phone/override/v1`, { method: "PUT", body: JSON.stringify(req, fm.replacer) });
    },
    // Delete the override
    Delete(fn, req) {
        try {
            fm.validateUrlParam(req["phoneOverrideId"], "phoneOverrideId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/phone/override/v1/${req["phoneOverrideId"]}?${fm.renderURLSearchParams(req, ["phoneOverrideId"])}`, { method: "DELETE" });
    },
};
